module.exports = __webpack_public_path__ + "media/images/flags/ph-00c939ce7a61613960b91abb1f32afec.svg";